import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneMask',
  standalone: true
})
export class PhoneMaskPipe implements PipeTransform {
  transform(value: string | null): string {
    if (!value || value === '--') return '--';

    // Remove non-numeric characters
    let cleanedValue = value.replace(/\D/g, '');

    if (cleanedValue.length === 11 && cleanedValue.startsWith('1')) {
      cleanedValue = cleanedValue.slice(1);
    }

    return cleanedValue.length === 10 
      ? `(${cleanedValue.slice(0, 3)}) ${cleanedValue.slice(3, 6)}-${cleanedValue.slice(6)}`
      : cleanedValue;
  }
}
